import React from "react";
import './CommingSoon.css';
import logoimage from './assets/miAuction.png';

const CommingSoon = () => {
    return (
        <div className="commingfield">
            <img src={logoimage} alt="Logo" className="logo-image" />            
        </div>
    );
};

export default CommingSoon;